import { Component, EventEmitter, Input, Output } from '@angular/core'
import { FormControl } from '@angular/forms'
import { generateUuid } from '@ftr/contracts/type/shared/Uuid'
import { DateFormat, DefaultTimeStringParseMethod, DurationTimeStringParseMethod } from '@ftr/foundation'
import { LocalTime } from '@js-joda/core'
import { Observable, of } from 'rxjs'
import { INVALID_TIME_MESSAGE, TimeInputComponent } from '../time-input'

@Component({
  standalone: true,
  selector: 'ftr-duration-input',
  imports: [TimeInputComponent],
  templateUrl: './duration-input.component.html',
})
/**
 * An input for entering duration values.  It will behave like an ftr-time-input control, but will assume the value entered is a duration instead of a time of day.
 */
export class DurationInputComponent {
  readonly timeStringParseMethods = [DurationTimeStringParseMethod, DefaultTimeStringParseMethod]
  readonly timeFormat = DateFormat.TimeTwentyFourHourPadded

  @Input() label: string = 'Time'

  @Input() id: string = generateUuid()

  @Input() name: string = 'duration'

  @Input() submitAttempted: boolean = false

  /**
   * The form control driving the value in this component.
   */
  @Input() control: FormControl<LocalTime | null>

  /**
   * Whether to highlight field errors, as per ftr-form.
   */
  @Input() highlightError: Observable<boolean> = of(false)

  /**
   * The placeholder for the input.
   */
  @Input() placeholder: string = 'HH:MM'

  @Input() invalidTimeMessage: string = INVALID_TIME_MESSAGE

  @Output() inputChanged = new EventEmitter<void>()

  onInputChanged(): void {
    this.inputChanged.emit()
  }
}
